import React from 'react';
import { FormattedNumber } from 'react-intl';

import { useUserStore } from 'v2/store/User';

interface IProps {
  value: any;
  separator?: string;
  format?: string;
}

const ColoredFormattedNumberForeign = (props: IProps) => {
  const { crossborder } = useUserStore(({ user }) => ({ crossborder: user.crossborder }));

  if (!crossborder) {
    return null;
  }

  return (
    <React.Fragment>
      {props.separator}{' '}
      <FormattedNumber value={props.value ? props.value : 0} format={props.format ? props.format : 'USD'} />
    </React.Fragment>
  );
};

export default ColoredFormattedNumberForeign;
